import { css } from 'styled-components';
import { VariantOfType } from '../../variants';

export const CssFormTesterDefault = css`
  padding: var(--form-control-padding);
  border: 1px solid var(--form-border-color-info);
  background: var(--form-background-color-info);
  color: var(--form-color-info);

  code {
    font-size: 0.8em;
    line-height: 1.3;
  }
`;

export const formTesterVariants = {
  default: CssFormTesterDefault,
};

export type IFormTesterVariants = VariantOfType<typeof formTesterVariants>;
